import React, { useState, useEffect } from 'react';
import "./_Header.scss"
import Dropdown from 'react-bootstrap/Dropdown';
import axios from 'axios';
import { useCombined } from '../CombinedContext';
import GlobalSearch from '../../../siteEngine/components/GlobalSearch';
import NotificationsDropdown from '../NotificationsDropdown/NotificationsDropdown';
import { fetchPendingRequests } from '../../../siteEngine/actions';
import { connect } from 'react-redux';


function Header(props) {
    const [actingAs, setActingAs] = useState(JSON.parse(sessionStorage.getItem('actAsPartner') || false));
    const [showActingAs, setShowActingAs] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [currentUser, setCurrentUser] = useState({});
    const [isFixed, setIsFixed] = useState(false);
    const [pendingRequests, setPendingRequests] = useState({});
    const isAuthenticated = window.sessionStorage.getItem("isAuthenticated");
   //let hostURL = location.protocol + '//' + location.host;
   let hostURL = 'https://' + location.host;
   const { showLoader, hideLoader, breadcrumbItems } = useCombined();
   function handleScroll(e) {
    const offset = window.innerWidth > 940 ? 99 : 125;
    if(window.scrollY > offset) {
        setIsFixed(true);
    }else {
        setIsFixed(false);
    }
   }
    useEffect (() => {
        const source = axios.CancelToken.source();
        getCurrentUser(source.token);

        window.addEventListener('scroll', handleScroll); 
        window.addEventListener('pageshow', handlePageShow);
   
        return () => {
            source.cancel('not mounted');
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('pageshow', handlePageShow);
        };
    },[])

    useEffect(() => {
        if (props.pendingRequestList.data) {
        hideLoader("fetchPendingRequest");
        setPendingRequests(props.pendingRequestList.data);
        }
    }, [props.pendingRequestList])

    useEffect(() => {
        if (props.errorResponse?.status == false) {
          hideLoader("failed");
        }
      }, [props.errorResponse])

    function handleLogin() {
        window.location.href = hostURL + '/auth/';
    }

    function handlePageShow(event) {
        if (sessionStorage.getItem('isLoggedOut')) {
            sessionStorage.removeItem('isLoggedOut'); 
            window.location.reload();
        }
    }
    
    function handleLogout() {
        window.sessionStorage.clear();
        sessionStorage.setItem('isLoggedOut', 'true');
        localStorage.clear();
        window.location.href = currentUser.logoutUrl;
    }

    function hideActAsToggle() {
        setShowActingAs(false);
        setActingAs(false);
        sessionStorage.actAsPartner = false;
    }

    async function fetchPendingRequest() {
        showLoader("fetchPendingRequest");
        props.dispatch(fetchPendingRequests());
    }

    async function getCurrentUser(token) {
        const controller = new AbortController();
        window.sessionStorage.removeItem("isUserAuthenticated");
        showLoader("header_current_user");
        try {
            console.log('hostURL:', hostURL);
            const response = await axios.get(`${hostURL}/auth/user/current/`,{
                cancelToken: token
            });
            hideLoader("header_current_user");
            if (response.status === 200 && response.data && response.data.remoteUser) {
                window.sessionStorage.setItem("isUserAuthenticated", "true");
                window.sessionStorage.setItem("remoteUser", response.data.remoteUser);
                if(actingAs && response.data.isPublisher) {
                    response.data.isPublisher = false;
                }
                setCurrentUser(response.data);
                setIsLoggedIn(true);
                fetchPendingRequest();
                if(response.data.actAsPartner) {
                    setShowActingAs(true);
                }else {
                    hideActAsToggle();
                }
                if (!window.location.pathname.includes('/auth/')) {
                    handleLogin();
                }
            } else {
                setIsLoggedIn(false);
                hideActAsToggle();
            }
        } catch (error) {
            hideActAsToggle();
            hideLoader("header_current_user");
            if (axios.isCancel(error)) {
                console.log('Request canceled', error.message);
            } else {
                console.error(error);
                setIsLoggedIn(false);
            }
        }
    }
    function refRequestAccess () {
        window.location.href = hostURL + '/auth/#request/';
    }

    function getHref (uri) {
        let retUrl = ""
        if(isAuthenticated) {
            retUrl +="/auth";
        }
        retUrl += uri ? `/${uri}/` : '/';
        return retUrl;
    }

    async function handleActingAs(e) {
       // sessionStorage.actAsPartner = e.target.checked;
       let actAsPartnerVal = e.target.checked;
        showLoader("header_current_user");
        const headers = {
            'Content-Type': 'application/json',
            'X-Act-As-Partner': actAsPartnerVal.toString()
          }
          
        try {
            const response = await axios.get(`${hostURL}/auth/actaspartner/`,{
                headers: headers
              });
            if (response.status === 200) {
                sessionStorage.actAsPartner = actAsPartnerVal.toString();
                setActingAs(actAsPartnerVal);
                setTimeout(() => location.reload(), 1000);
            } else {
                setActingAs(false);
                hideLoader("header_current_user");
            }
        } catch (error) {
            setActingAs(false);
            hideLoader("header_current_user");
        }

       
    }

    function getFixedHeader(className='') {
        return <div className={`fixed-act-as-partner ${className}`}>
            <hbr-banner
                closable="false"
                class="atm-banner--system"
                sentiment="warning"
                open="true"
            >
                <i slot="icon" class="atm-icon warning-outline"></i>
                You are now viewing this page as a <strong>Partner</strong>. Certain features and content may differ.
            </hbr-banner>
        </div>
    }

    function getInternalBanner(className='') {
        return <div className={`internal-warning-banner ${className}`}>
            <div className="container-fluid" style={{padding: "unset"}}>
                <div className="internal-warning-content">
                    <i className="atm-icon warning" aria-hidden="true"></i>
                    <span>
                        Commerce API's are strictly for the use of Cisco Partners, Distributors and Customers.
                        Usage by Cisco badged employees is not supported.
                    </span>
                </div>
            </div>
        </div>
    }

    useEffect(() => {
        (function(){
            var g = function(e,h,f,g){
                this.get = function(a){
                    for(var a=a+"=",c=document.cookie.split(";"),b=0,e=c.length;b<e;b++){
                        for(var d=c[b];" "==d.charAt(0);) d=d.substring(1,d.length);
                        if(0==d.indexOf(a)) return d.substring(a.length,d.length)
                    }
                    return null
                };
                this.set = function(a,c){
                    var b="",b=new Date;
                    b.setTime(b.getTime()+6048E5);
                    b="; expires="+b.toGMTString();
                    document.cookie=a+"="+c+b+"; path=/; "
                };
                this.check = function(){
                    var a=this.get(f);
                    if(a) a=a.split(":");
                    else if(100!=e) "v"==h&&(e=Math.random()>=e/100?0:100), a=[h,e,0], this.set(f,a.join(":"));
                    else return!0;
                    var c=a[1];
                    if(100==c) return!0;
                    switch(a[0]){
                        case "v": return!1;
                        case "r": c=a[2]%Math.floor(100/c), a[2]++, this.set(f,a.join(":")), !c
                    }
                    return!0
                };
                this.go = function(){
                    if(this.check()){
                        // Restrict the Qualtrics loader to an expected HTTPS host.
                        try {
                            var url = new URL(g, window.location.href);
                            if (url.protocol !== "https:" || url.hostname !== "zn2vt1e3pslctjxep-ciscocx.siteintercept.qualtrics.com" || url.pathname !== "/SIE/") {
                                return;
                            }
                        } catch (e) {
                            return;
                        }
                        var b=document.currentScript || document.querySelector("script");
                        if (!b || !document.body) {
                            return;
                        }
                        var a=b.cloneNode(!1);
                        a.type="text/javascript";
                        a.src=g;
                        document.body.appendChild(a)
                    }
                };
                this.start = function(){
                    var t=this;
                    "complete"!==document.readyState ? window.addEventListener ? window.addEventListener("load", function(){t.go()}, !1) : window.attachEvent && window.attachEvent("onload", function(){t.go()}) : t.go()
                };
            };
            try{
                (new g(100,"r","QSI_S_ZN_2Vt1e3pslCtjxEP","https://zn2vt1e3pslctjxep-ciscocx.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_2Vt1e3pslCtjxEP")).start()
            } catch(i){}
        })();
    }, []);

    return (
        <>
            <div className="border-header">
                <div className="d-flex px-3 px-sm-4 container-fluid justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <div className='d-flex align-items-center pe-4'>
                            <a href={getHref('')} className='header-logo'>
                                <svg width="44" height="10" viewBox="0 0 46 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.9285 4.85421L20.2651 4.64681C19.881 4.50854 19.1826 4.3357 19.1826 3.74804C19.1826 3.29866 19.7064 2.95298 20.6492 2.95298C21.4872 2.95298 22.4998 3.22952 22.5348 3.22952V1.19002C22.4649 1.15545 21.3824 0.878906 20.1952 0.878906C17.9954 0.878906 16.6685 2.05421 16.6685 3.85175C16.6685 5.4073 17.7858 6.20236 19.1127 6.61718C19.2524 6.65175 19.4619 6.72088 19.6365 6.79002C20.2301 6.96286 20.6841 7.2394 20.6841 7.72335C20.6841 8.27644 20.1254 8.62212 18.9382 8.62212C17.8906 8.62212 16.878 8.311 16.6685 8.27644V10.4542C16.7732 10.4888 17.9954 10.6962 19.2524 10.6962C21.0682 10.6962 23.1633 9.90113 23.1633 7.51594C23.1982 6.40977 22.4649 5.33817 20.9285 4.85421ZM42.7176 5.85668C42.7176 4.47397 41.6701 3.3678 40.2384 3.3678C38.8068 3.3678 37.7592 4.47397 37.7592 5.85668C37.7592 7.2394 38.8068 8.34557 40.2384 8.34557C41.6701 8.34557 42.7176 7.2394 42.7176 5.85668ZM45.2667 5.85668C45.2667 8.55298 43.1716 10.7653 40.2733 10.7653C37.3402 10.7653 35.28 8.55298 35.28 5.85668C35.28 3.16039 37.3751 0.948042 40.2733 0.948042C43.1716 0.948042 45.2667 3.12582 45.2667 5.85668ZM0.536133 5.85668C0.536133 8.89866 2.91059 10.7653 5.56439 10.7653C6.64686 10.7653 7.44999 10.5234 7.76425 10.4196V7.86162C7.6595 7.93076 6.89129 8.34557 5.73898 8.34557C4.13273 8.34557 3.1201 7.2394 3.1201 5.82212C3.1201 4.37026 4.20257 3.29866 5.73898 3.29866C6.89129 3.29866 7.6595 3.74804 7.76425 3.81718V1.25915C7.55474 1.19002 6.7167 0.913474 5.56439 0.913474C2.66616 0.948042 0.536133 3.02212 0.536133 5.85668ZM25.5028 5.85668C25.5028 8.89866 27.8773 10.7653 30.566 10.7653C31.6136 10.7653 32.4516 10.5234 32.7309 10.4196V7.86162C32.6262 7.93076 31.858 8.34557 30.7057 8.34557C29.0994 8.34557 28.0868 7.2394 28.0868 5.82212C28.0868 4.37026 29.1693 3.29866 30.7057 3.29866C31.858 3.29866 32.6262 3.74804 32.7309 3.81718V1.25915C32.5214 1.19002 31.6834 0.913474 30.566 0.913474C27.6328 0.948042 25.5028 3.02212 25.5028 5.85668ZM11.0466 1.12088H13.421V10.5925H11.0466V1.12088Z" fill="#133967" />
                                </svg>
                                <p className="header-logo-text">IT API Portal</p>
                            </a>
                        </div>
                        <a href={getHref('getting-started')} className='header-link'>Getting Started</a>
                        <a href={getHref('whats-new')} className='header-link'>What's New</a>
                    </div>

                    <div className='d-flex align-items-center'>
                        <div className='me-3'>
                            { breadcrumbItems && breadcrumbItems.length > 1 && <GlobalSearch className="d-none d-md-flex" showIcon={true} /> }
                        </div>
                        <div className='border-end border-secondary-subtle me-3'>
                            {!actingAs && <NotificationsDropdown pendingRequests={pendingRequests} isLoggedIn={isLoggedIn} />}
                        </div>

                        <div id='ZN_2Vt1e3pslCtjxEP'></div>

                        {!isLoggedIn ? (
                            <p className='mb-0 text-primary login-text' onClick={handleLogin}>LOGIN</p>   
                        ):(
                            <Dropdown>
                                <Dropdown.Toggle as="div" id="dropdown-custom-components" className="user-logo no-caret">
                                    {currentUser.firstName[0]}{currentUser.lastName[0]}
                                </Dropdown.Toggle>
                            
                                <Dropdown.Menu className='pb-0'>
                                    <div className='drop-down-container'>
                                        <div className='d-flex profile-container px-4 py-3'>
                                            <div className='user-logo'>{currentUser.firstName[0]}{currentUser.lastName[0]}</div>
                                            <div className='ms-3'>
                                                <p className='user-name'>{currentUser.firstName} {currentUser.lastName}</p>
                                                {showActingAs && <div className='pt-1'>
                                                    <hbr-switch checked={actingAs} value={actingAs} onInput={handleActingAs}>Act as Partner</hbr-switch>
                                                </div>}
                                            </div>
                                        </div>  
                                    </div>

                                    <Dropdown.Item href='/auth/#my_apps/' className='dropDown-optn border-top border-light-subtle'> <p className='ps-2 my-2'> My Apps <br/> <span className='sub-txt'>You can view all your applications </span></p></Dropdown.Item>
                                    { currentUser.isSiteOwner && 
                                    <>
                                        <Dropdown.Item href='/auth/#my_sites/' className='dropDown-optn border-top border-light-subtle'> <p className='ps-2 my-2'> My Sites <br/> <span className='sub-txt'>You can view all your sites</span></p></Dropdown.Item>
                                    </>
                                    }
                                    { currentUser.isPublisher && 
                                   <>
                                    <Dropdown.Item href='/auth/#request/' className='dropDown-optn border-top border-light-subtle'> <p className='ps-2 my-2'> API Access Request Management <br/> <span className='sub-txt'>Your dashboard to approve or deny access to API’s </span></p></Dropdown.Item>
                                    <Dropdown.Item href='/auth/#api_metrics/' className='dropDown-optn border-top border-light-subtle'> <p className='ps-2 my-2'> My APIs Metrics <br/> <span className='sub-txt'>Your dashboard to view APIs metrics </span></p></Dropdown.Item>
                                   </>
                                   }
                                    <Dropdown.Item onClick={handleLogout} className='dropDown-optn border-top border-light-subtle'> <p className='ps-2 my-2'> Logout <i class="atm-icon arrow-right-tail logout-icon ms-2"/></p></Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        )}
                    </div>
                </div>
            </div>
            {showActingAs && actingAs && getFixedHeader()}
            {showActingAs && actingAs && isFixed && getFixedHeader('act-position-fixed')}
            {!actingAs && sessionStorage.getItem('accessLevel') == 4 && (props.meta?.doc_page_url || '').includes("cisco-commerce") && getInternalBanner()}
        </>
    )
}

const mapStateToProps = (state) => ({
    pendingRequestList: state.access.pendingRequestList,
    errorResponse: state.access.errorResponse
  });

export default connect(mapStateToProps)(Header);
